import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

const AlertCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#FF5252" />
    <rect x="11" y="7" width="2" height="6" rx="1" fill="#fff" />
    <rect x="11" y="15" width="2" height="2" rx="1" fill="#fff" />
  </SvgIcon>
);

export default AlertCircleIcon;
